import { adoptStyles } from 'lit';

class ElementStylerMap {
    sourceElement: Element; // The element that is the source of the styles.
    rootStyles: Array<string> = []; // Array of root styles i.e. .xtdw, .xtecx, descendants will inherit combined with variants.
    generalAttributes: Array<string> = []; // Array of general attributes i.e. --attribute1, --attribute2, descendants will inherit.
    childVariants: Map<Element, Array<string>> = new Map(); // Map of child elements to their variants i.e. -variant1, -variant2
    constructor(sourceElement: Element) {
        this.sourceElement = sourceElement;
    }
}

const objMap: WeakMap<Element, ElementStylerMap> = new WeakMap<Element, ElementStylerMap>();

function GetChildrenStylerMap(parent: Element, forceScan: boolean): ElementStylerMap {
    let map = objMap.get(parent);
    if (!map) forceScan = true; //if map is not found, then force scan.    
    map ??= objMap.set(parent, new ElementStylerMap(parent)).get(parent)!;
    Array.from(parent.classList).forEach(function (suspect) {
        if (suspect.substring(0, 2) === "--") {
            var variant = suspect.substring(2);
            parent.classList.remove(suspect); //no need to keep it laying around
            map!.generalAttributes.push(variant);
        }
    });

    if (forceScan) VisitSubVariants(parent, map.childVariants, parent);
    return map;
}

function VisitSubVariants(cur: Element, variantMap: Map<Element, string[]>, parent: Element) {
    if (cur.hasAttribute("id") && cur !== parent) return null; //prevents to dig into another object with an id. (also checks that it can go in the first time)
    if (cur.hasChildNodes())
        Array.from(cur.children).forEach(function (d) {
            VisitSubVariants(d, variantMap, parent);
        });
    Array.from(cur.classList).forEach(function (suspect) {
        if (suspect.substring(0, 1) === "-") {
            var variant = suspect.substring(1);
            //cur.classList.remove(suspect); //no need to keep it laying around
            var variantArray = variantMap.get(cur) || variantMap.set(cur, new Array()).get(cur);
            variantArray!.push(variant);
        }
    });
    return null;
}


function ElementVisitorSetter(cur: Element, map: ElementStylerMap) {
    if (cur.hasAttribute("id") && (cur !== map.sourceElement)) return; //prevents to dig into another object with an id.    
    if (cur.hasChildNodes())
        Array.from(cur.children).forEach(function (d) {
            ElementVisitorSetter(d, map);
        });
    if (cur.shadowRoot) {
        Array.from(cur.shadowRoot.children).forEach(function (shadowChild) {
            ElementVisitorSetter(shadowChild, map);
        });
    }
    cur.classList.forEach(function (suspect) {
        if (suspect.substring(0, 1) === "-") {
            var variant = suspect.substring(1);
            map.rootStyles.forEach(function (rootStyle) { cur.classList.add(rootStyle + "-" + variant); });
        }
    });
    map.generalAttributes.forEach(function (attr) { cur.classList.add(attr); });
}

export function SetStylesInElement(element: Element) {
    if (!objMap.has(element)) return; //if element is not found, then there is no point in continuing.
    var map = GetChildrenStylerMap(element, false);
    ElementVisitorSetter(element, map);
}

export function ApplyStylesToDependant(parent: Element, child: Element) {
    if (!objMap.has(parent)) return; //if element is not found, then there is no point in continuing.
    var map = GetChildrenStylerMap(parent, false);
    ElementVisitorSetter(child, map);
}


export let sharedStylesheet: CSSStyleSheet | null = null;
function initializeSharedStylesheet() {
    if (sharedStylesheet) return;

    //base64 string of the stylesheet is in window.__lorbizCss.currentFileB64

    sharedStylesheet = new CSSStyleSheet();
    const b64 = (window as any).__lorbizCss?.currentFileB64;
    if (!b64) {
        console.warn('No stylesheet found in __lorbizCss.currentFileB64');
        return;
    }
    try {
        const decoded = atob(b64);
        const rules = decoded.split('\n').map(line => line.trim()).filter(line => line.length > 0).join('\n');
        sharedStylesheet.replaceSync(rules);
    } catch (e) {
        console.warn('Error decoding or applying stylesheet:', e);
        sharedStylesheet = null;
    }
    if (!sharedStylesheet) {
        console.warn('Failed to create shared stylesheet');
        return;
    }

    document.adoptedStyleSheets = [sharedStylesheet]; //adopt the new stylesheet.



}


initializeSharedStylesheet();
// export function SetSharedStyleSheetToLitElement(element: Element) {
//     if (!sharedStylesheet) {
//         console.warn('Shared stylesheet is not initialized');
//         return;
//     }
//     if (element.shadowRoot) {
//         adoptStyles(element.shadowRoot, [sharedStylesheet]);
//     } else {
//         console.warn('Element does not have a shadow root');
//     }
// }






export var thisclass = {
    setclass: function (id: number, cl: string) {
        var parent = (window as any).oos(id) as Element;
        var map = GetChildrenStylerMap(parent, true);
        if (cl) map.rootStyles.push(cl);
        if (cl) parent.classList.add(cl);
        map.generalAttributes.forEach(function (attr: string) { parent.classList.add(attr); });
        if (!parent.hasChildNodes) return; //if parent has no children, then there is no point in continuing.
        for (const [thisChild, variantArray] of map.childVariants.entries()) {
            if (cl) {
                variantArray.forEach(function (v) {
                    thisChild.classList.add(cl + "-" + v);
                });
            }
            map.generalAttributes.forEach(function (attr) { thisChild.classList.add(attr); });
        }
        if (cl) if (typeof (parent as any).cssPush === "function") (parent as any).cssPush(cl);
    },







    bsync: function (rid: number) {
        var browserCssRules = new Array();
        Array.from([sharedStylesheet]).forEach(function (styleSheet) {
            try {
                Array.from(styleSheet!.cssRules).forEach(function (rule) {
                    try {
                        browserCssRules.push(rule);
                    } catch (e) {
                    };
                });
            } catch (error) {
                //console.log(error);
            }
        });

        var fullMap = new Map();
        browserCssRules.filter(x => x.style).map(function (q) { return { n: q.selectorText, t: q.style.cssText }; })
            .filter(x => x.n !== undefined && x.t !== undefined && x.t !== undefined)
            .forEach(x => fullMap.set(x.n, x.t));

        Array.from(document.body.querySelectorAll("*")).forEach(o => {
            if (!o.classList) return; // object does not have classList.
            o.classList.forEach(cl => {
                var suspectClass = '.' + cl;
                if (!fullMap.has(suspectClass)) fullMap.set(suspectClass, "");
            });
        });


        var ruleSet = new Array();
        var iterator = fullMap.entries();
        var cursor = null;;
        while (!(cursor = iterator.next()).done
        ) ruleSet.push({ n: cursor.value[0], t: cursor.value[1] }); //build object from map.


        (window as any).jsE(rid, JSON.stringify(ruleSet));
    },


    reload: function (a:any) {
        var links = window.document.getElementsByTagName("link");
        for (var cl in links) {
            if (links.hasOwnProperty(cl)) {
                var link = links[cl];
                if (link?.rel === "stylesheet") {
                    link.href = "/static/3ecb7e2d-8676-4e2a-a86c-a0908cf0c7bd/" +
                        Math.random().toString().replace(".", "") +
                        ".css";
                    return;
                }
            }
        }
    }


}